import _, { isEmpty } from 'underscore';

export const YOUTUBE_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=))((\w|-){11})/;
export const YOUTUBE_NOT_SUPPORT_TYPE_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:youtube\.com\/playlist\?list=|youtube\.com\/user\/)/;
export const VIMEO_REGEX = /^(?:https?:\/\/)?(?:www\.|m\.)?vimeo\.com\/.+/;

export const validateEmailAddress = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const isLengthValidated = (email && email.length <= 100);
  return re.test(email) && isLengthValidated;
};

export const prependProtocolToUrl = (url) => {
  if (!url) {
    return '';
  }

  const urlToCheck = url.toLowerCase();
  let prefix = '';

  if (!(urlToCheck.startsWith('https://') || urlToCheck.startsWith('http://'))) {
    prefix = 'https://'; // Default to https
  }

  return prefix + url;
};

// We prepend the protocol before validating
export const isValidUrl = (str) => {
  try {
    const strToConvert = prependProtocolToUrl(str);
    const url = new URL(strToConvert);

    return !_.isEmpty(url.host);
  } catch (ex) {
    return false;
  }
};

export const getYoutubeVideoId = (url) => {
  const videoUrl = prependProtocolToUrl(url);

  if (YOUTUBE_REGEX.test(videoUrl)) {
    return videoUrl.match(YOUTUBE_REGEX)[1];
  }

  return '';
};

// Check if url is smart page support url, currently only support youtube or vimeo
export const isSmartPageSupportVideo = (url) => {
  const videoWebsiteWhitelist = [
    YOUTUBE_REGEX,
    YOUTUBE_NOT_SUPPORT_TYPE_REGEX,
    VIMEO_REGEX,
  ];

  for (let i = 0; i < videoWebsiteWhitelist.length; i += 1) {
    if (videoWebsiteWhitelist[i].test(url)) {
      return true;
    }
  }

  return false;
};

/* running through validators and generate first error message for name.
example arr
[
  {
    name: 'a',
    value: 'test value',
    validators: [{
      validateWhenTrue: () => true ,
      validator: (value) => false,
      errorMessage: 'error message',
    }]
  }
]

example return value:
{
  a: 'error message',
}
*/
export const validate = (arr) => {
  const errors = {};

  _.each(arr, ({
    name,
    value,
    validators,
  }) => {
    for (let i = 0; i < validators.length; i += 1) {
      const { validateWhenTrue, validator, errorMessage } = validators[i];
      if (validateWhenTrue) {
        if (!validator(value)) {
          errors[name] = errorMessage;
          break;
        }
      }
    }
  });

  return errors;
};

export const getPathFromUrl = (url) => {
  if (isEmpty(url)) {
    return '';
  }

  return url.split('?')[0];
};
